module.exports = __webpack_public_path__ + "img/mobile2.b68e685c.svg";